import { render, staticRenderFns } from "./ListElement.vue?vue&type=template&id=5227b9e6&scoped=true&"
import script from "./ListElement.vue?vue&type=script&lang=js&"
export * from "./ListElement.vue?vue&type=script&lang=js&"
import style0 from "./ListElement.vue?vue&type=style&index=0&id=5227b9e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5227b9e6",
  null
  
)

export default component.exports